import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import type * as React from 'react';
import type { IntlShape } from 'react-intl';

import type { LegacyPOI } from './POIAndGeofenceTable';

const isPolygonalGeofence = (radius: number) => radius < 0;

const isPoi = (poi: LegacyPOI) => !poi.radius;

export const typeFormatter = (radiusWithUnit: string | undefined, entry: LegacyPOI, intl: IntlShape) => {
    if (!radiusWithUnit) {
        return (
            <div>
                <span
                    title={intl.formatMessage({ id: 'intl-msg:table.type.poi' })}
                    className='uikit-icon icon-poi text-size-18 text-color-dark'
                />
            </div>
        );
    }
    if (isPolygonalGeofence(entry.radiusSort)) {
        return (
            <div>
                <span
                    title={intl.formatMessage({ id: 'intl-msg:table.type.geofence.polygonal' })}
                    className='uikit-icon icon-polygon text-size-18 text-color-dark'
                />
            </div>
        );
    }
    return (
        <div>
            <span
                title={intl.formatMessage({ id: 'intl-msg:table.type.geofence.circular' })}
                className='uikit-icon icon-sphere margin-right-5 text-size-18 text-color-dark'
            />
            <span className='text-color-dark'>( {radiusWithUnit} )</span>
        </div>
    );
};

export const createClickHandler =
    (geofenceId: string, callback: (id: string) => void) => (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault();
        callback(geofenceId);
    };

export const createButtonFormatter = (
    onDelete: (id: string) => void,
    onPoiUpdate: (id: string) => void,
    onGeofenceUpdate: (id: string) => void,
    allowedToEdit: boolean,
    allowedToDelete: boolean,
    geofenceId: string,
    poi: LegacyPOI
) => {
    const editClickHandler = isPoi(poi)
        ? createClickHandler(geofenceId, onPoiUpdate)
        : createClickHandler(geofenceId, onGeofenceUpdate);

    const createTestId = (type: string): string =>
        isPoi(poi) ? `poi:${type}:${geofenceId}` : `geofence:${type}:${geofenceId}`;

    return (
        <ButtonToolbar alignment='right' className='gap-5'>
            <Button
                variant='link'
                onClick={editClickHandler}
                disabled={!allowedToEdit}
                data-testid={createTestId('edit')}
                iconName='pencil'
                iconOnly
            />
            <Button
                bsStyle='muted'
                onClick={createClickHandler(geofenceId, onDelete)}
                disabled={!allowedToDelete}
                data-testid={createTestId('delete')}
                iconName='trash'
                className='text-color-gray hover-text-color-danger'
                iconOnly
            />
        </ButtonToolbar>
    );
};
